import { ContainerModule } from "inversify";
import { MinhasEmpresasHandler } from "../handlers/MinhasEmpresasHandler";
import { AbstractCSAT } from "../AbstractCSAT";
import { AbstractCSATGatewayHandler } from "../handlers/AbstractCSATGatewayHandler";
import {
  ISalvarAvaliacaoCSATMinhasEmpresasGateway,
  SalvarAvaliacaoMinhasEmpresasParams
} from "../ports/SalvarAvaliacaoCSATMinhasEmpresasGateway";
import { CSATMinhasEmpresasGatewayHandler } from "../handlers/MinhasEmpresasGatewayHandler";
import { SalvarCSATMinhasEmpresasUseCaseAdapter } from "../adapters/SalvarCSATMinhasEmpresasAdapter";
import { ISalvarCSATMinhasEmpresasUseCase } from "../ports/SalvarCSATMinhasEmpresasUseCase";
import { SalvarAvaliacaoCSATMinhasEmpresasGateway } from "../adapters/SalvarAvaliacaoCSATMinhasEmpresasGateway";
import {
  IPodeVisualizarPesquisaCSATUseCase,
  podeVisualizarPesquisaCSATUseCaseDI
} from "../ports/PodeVisualizarPesquisaCSATUseCase";
import { PodeVisualizarPesquisaCSATUseCaseAdapter } from "../adapters/PodeVisualizarPesquisaCSATUseCaseAdapter";
import {
  IPesquisaCSATAtivaGateway,
  pesquisaCSATAtivaGatewayDI
} from "../ports/PesquisaCSATAtivaGateway";
import { PesquisaCSATAtivaGatewayAdapter } from "../adapters/PesquisaCSATAtivaGatewayAdapter";
import {
  ignorarPesquisaCSATUseCaseDI,
  IIgnorarPesquisaCSATUseCase
} from "../ports/IgnorarPesquisaCSATUseCase";
import { IgnorarPesquisaCSATUseCaseAdapter } from "../adapters/IgnorarPesquisaCSATUseCaseAdapter";

export const CSATContainer = new ContainerModule((bind) => {
  bind<AbstractCSATGatewayHandler<SalvarAvaliacaoMinhasEmpresasParams>>(
    CSATMinhasEmpresasGatewayHandler
  )
    .toSelf()
    .inSingletonScope();
  bind<ISalvarCSATMinhasEmpresasUseCase>(SalvarCSATMinhasEmpresasUseCaseAdapter)
    .toSelf()
    .inSingletonScope();
  bind<ISalvarAvaliacaoCSATMinhasEmpresasGateway>(
    SalvarAvaliacaoCSATMinhasEmpresasGateway
  )
    .toSelf()
    .inSingletonScope();
  bind<AbstractCSAT<unknown>>(MinhasEmpresasHandler)
    .toSelf()
    .inSingletonScope();
  bind<IPesquisaCSATAtivaGateway>(pesquisaCSATAtivaGatewayDI)
    .to(PesquisaCSATAtivaGatewayAdapter)
    .inRequestScope();
  bind<IPodeVisualizarPesquisaCSATUseCase>(podeVisualizarPesquisaCSATUseCaseDI)
    .to(PodeVisualizarPesquisaCSATUseCaseAdapter)
    .inRequestScope();
  bind<IIgnorarPesquisaCSATUseCase>(ignorarPesquisaCSATUseCaseDI)
    .to(IgnorarPesquisaCSATUseCaseAdapter)
    .inRequestScope();
});
